// @flow

export { CanceledPaymentPage as default } from './canceled-payment';
